import { inventoryItemIdFormat } from "@redotech/redo-ims-id";
import {
  sortDestinationIdFormat,
  stationProcessingSessionIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { StationProcessingSessionToteBindingViewSchema } from "./station-processing-session";

export const recordItemSort = {
  name: "recordItemSort" as const,
  input: z.object({
    sessionId: stationProcessingSessionIdFormat.schema,
    inventoryItemId: inventoryItemIdFormat.schema,
    sortDestinationId: sortDestinationIdFormat.schema,
  }),
  output: z.object({
    bindings: z.array(StationProcessingSessionToteBindingViewSchema),
    sortedTo: z.object({
      storageLocationId: storageLocationIdFormat.schema,
      toteName: z.string(),
      sortDestinationId: sortDestinationIdFormat.schema,
      destinationName: z.string(),
    }),
  }),
};
